import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeExcept'
})
export class CapitalizeExceptPipe implements PipeTransform {

  private excludedWords: string[] = ['el', 'la', 'los', 'las', 'un', 'una', 'unos', 'unas', 'de', 'por', 'y', 'o', 'a', 'en'];

  transform(value: string): string {
    if (!value) return '';

    return value.split(' ').map((word, index) => {
      if (this.excludedWords.includes(word.toLowerCase()) && index !== 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }
}
